import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import { IconAngleRight, IconAngleLeft } from '../Icon'

import styles from './Carousel.module.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const defaultProps = {
  arrows: false,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 3,
  swipeToSlide: true,
  lazyLoad: true,
  centerMode: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
}

const propTypes = {
  // compose a className on the carsousel container
  className: PropTypes.string,
  // compose a className on the slider container
  sliderClassName: PropTypes.string,
  // takes an array of react components you want to render
  slides: PropTypes.arrayOf(PropTypes.node),
  // show dots
  dots: PropTypes.bool,
  // slow arrows
  arrows: PropTypes.bool,
  // infinite scroll
  infinite: PropTypes.bool,
  // animation speed in ms
  speed: PropTypes.number,
  // center active slide,
  centerMode: PropTypes.bool,
  // how many slides to scroll at once
  slidesToScroll: PropTypes.number,
  // number of slies to show at a time
  slidesToShow: PropTypes.number,
  // enable drag/swipe
  swipeToSlide: PropTypes.bool,
  // enable dragging on desktop
  draggable: PropTypes.bool,
  // ability to change props at certain media queries, example in default above
  responsive: PropTypes.arrayOf(PropTypes.object)
}

const CarouselSlidePropTypes = {
  slide: PropTypes.element,
  index: PropTypes.number
}

const NextArrowPropTypes = {
  onClick: PropTypes.func
}

const PrevArrowPropTypes = {
  onClick: PropTypes.func
}

const CarouselSlide = ({ slide }) => {
  return <>{slide}</>
}

const NextArrow = ({ onClick }) => {
  return (
    <button
      className={classnames(styles.slickArrow, styles.slickNext)}
      onClick={onClick}
    >
      <IconAngleRight className={styles.icon} />
    </button>
  )
}

const PrevArrow = ({ onClick }) => {
  return (
    <button
      className={classnames(styles.slickArrow, styles.slickPrev)}
      onClick={onClick}
    >
      <IconAngleLeft className={styles.icon} />
    </button>
  )
}

const Carousel = ({
  className,
  sliderClassName,
  slides,
  dots,
  arrows,
  infinite,
  speed,
  slidesToScroll,
  slidesToShow,
  swipeToSlide,
  centerMode,
  draggable,
  responsive,
  ...restProps
}) => {
  return (
    <div className={classnames(styles.carouselContainer, className)}>
      <Slider
        className={sliderClassName}
        dots={dots}
        arrows={arrows}
        infinite={infinite}
        speed={speed}
        slidesToScroll={slidesToScroll}
        slidesToShow={slidesToShow}
        swipeToSlide={swipeToSlide}
        draggable={draggable}
        centerMode={centerMode}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        responsive={responsive}
        {...restProps}
      >
        {slides.map((slide, index) => (
          <CarouselSlide slide={slide} key={index} />
        ))}
      </Slider>
    </div>
  )
}

Carousel.defaultProps = defaultProps
Carousel.propTypes = propTypes
CarouselSlide.propTypes = CarouselSlidePropTypes
NextArrow.propTypes = NextArrowPropTypes
PrevArrow.propTypes = PrevArrowPropTypes

export default Carousel
